import React from "react";
import type { ComponentProps, PartData } from "@enonic/react-components";
import type { ButtonProps } from "./Button.d";

export const ButtonPart = (props: ComponentProps<PartData>) => {
  const {
    backgroundColor = "",
    margin = "",
    title = "",
    url,
  } = (props.data as ButtonProps) ?? {};

  const handleClick = () => {
    if (!url) return;

    const isExternal = /^https?:/i.test(url);

    // runs only in browser; safe with SSR
    if (typeof window !== "undefined") {
      if (isExternal) {
        window.open(url, "_blank", "noopener,noreferrer");
      } else {
        window.location.href = url;
      }
    }
  };

  const className = ["btn", backgroundColor, margin].filter(Boolean).join(" ");

  return (
    <button
      type="button"
      onClick={handleClick}
      className={className}
      disabled={!url}
      aria-disabled={!url}
    >
      {title || "Button"}
    </button>
  );
};

export default ButtonPart;
